module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar identicon",
    class: _vm.sizeClass,
    style: (_vm.identiconStyles)
  }, [_vm._v("\n  " + _vm._s(_vm.identiconTitle) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cda97d4c"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/identicon.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cda97d4c"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/identicon.vue
// module chunks = main